import { wishSelectors } from "@/slices/wishSlice"
import { useReduxDispatch } from "@/store/useReduxDispatch"
import { updateSettingsThunk } from "@/thunks/settingsThunks"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router"
import "./adminPage.scss"
import { BasePage } from "@/components/layout/BasePage"

const AdminPage = (): JSX.Element => {
  const dispatch = useReduxDispatch()
  const navigate = useNavigate()

  const wishlists = useSelector(wishSelectors.wishLists)

  const changeTheme = (showOwners: EOwner[], themeType: EThemeType) => {
    dispatch(
      updateSettingsThunk({
        showOwners,
        themeType,
      })
    )
  }

  return (
    <BasePage
      className="admin-page"
      title="Indstillinger"
      topRightContent={<button onClick={() => navigate("/")}>Tilbage</button>}
    >
      <div className="admin-page__theme">
        <h2>Skift tema</h2>
        <button
          onClick={() => {
            changeTheme(["christian", "common"], "christianBirthday")
          }}
        >
          Christians fødselsdag
        </button>
        <button
          onClick={() => {
            changeTheme(["marina", "common"], "marinaBirthday")
          }}
        >
          Marinas fødselsdag
        </button>
        <button
          onClick={() => {
            changeTheme(["marina", "christian", "common"], "christmas")
          }}
        >
          Jul
        </button>
      </div>
    </BasePage>
  )
}

export default AdminPage
